﻿import controller from '../../../../Resources/Scripts/_Shared/controller';
import URLSearchParams from '@ungap/url-search-params';

import { openOverlay } from '../../_Shared/Scripts/MyAimoParkOverlay'
import { openOverlay as openPermitOverlay } from '../../_Shared/Scripts/LandlordPermitOverlay'
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'

function landlordPeopleOrganizationsPage(context) {
  const overlayContext = context.querySelector("[data-controller=myaimopark-overlay]");
  const permitOverlayContext = context.querySelector("[data-controller=landlord-permit-overlay]");

  function init() {
    context.addEventListener('click', async function (event) {
      if (event.target.dataset.addNew) {
        event.preventDefault();
        openOverlay(overlayContext, { heading: event.target.dataset.heading, hideLoader: true });
      } else if (event.target.dataset.createPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const subHeading = event.target.dataset.subHeading;
        const customerNumber = event.target.dataset.customerNumber;

        openPermitOverlay(permitOverlayContext, { heading, subHeading, customerNumber, hideLoader: true });
      }
      else if (event.target.dataset.editPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const subHeading = event.target.dataset.subHeading;
        const permitId = event.target.dataset.permitId;

        openPermitOverlay(permitOverlayContext, { heading, subHeading, permitId, hideLoader: true });

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('permitId', permitId);

        const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
        history.replaceState(paramsToObject(urlParams), document.title, newUrl);
       }
    });

    if (new URLSearchParams(window.location.search).get('newuser')) {
      context.querySelector('button[data-add-new]')?.click();
      history.replaceState({}, document.title, window.location.origin + (window.location.pathname + "/").replace('//', '/') + (window.location.search.split('&')[1] ? '?' + window.location.search.split('&')[1] : ''));
    }
    const permitIdQuery = new URLSearchParams(window.location.search).get('permitId');
    if (permitIdQuery) {
      const permitListItem = context.querySelector(`.landlordsinglepersonorganizationpage__list li a[data-permit-id="${permitIdQuery}"]`);

      if (permitListItem) {
        const heading = permitListItem.dataset.heading;
        const subHeading = permitListItem.dataset.subHeading;
        const permitId = permitListItem.dataset.permitId;

        openPermitOverlay(permitOverlayContext, { heading, subHeading, permitId, hideLoader: true });
      }
    }
  }

  return {
    init
  };
}

controller.add('landlord-people-organization-page', landlordPeopleOrganizationsPage);